import { render } from "./Pages.vue?vue&type=template&id=f8c31f22&ts=true"
import script from "./Pages.vue?vue&type=script&lang=ts"
export * from "./Pages.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__